module.exports = __webpack_public_path__ + "static/3-3040c45228e6bf96abf4ad3542701d07.jpeg";